import fetch from 'isomorphic-fetch';
import {getToken} from './getToken';

// const BASE_URL = window.configuration.baseUrl;
const AWS_URL = window.configuration.awsUrl;

export function saveFormState(formId, newState) {
  return new Promise((resolve, reject) => {
    getToken().then(token => {
      return fetch(`${AWS_URL}api/survey/manager/${formId}/change-state/${newState}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        method: 'post',
        // body: JSON.stringify(data)
      }).then(response => resolve (response.json())); 
    });
  });
}


export function saveFormData(formId, data) {
  return new Promise((resolve, reject) => {
    getToken().then(token => {
      return fetch(`${AWS_URL}api/survey/${formId}/savedata`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        method: 'post',
        body: JSON.stringify(data)
      }).then(response => resolve (response.json())); 
    });
  });
}

export function fetchFormData(formId) {
  return new Promise((resolve, reject) => {
    getToken().then(token => {
      return fetch(`${AWS_URL}api/getdata/${formId}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        method: 'get'
      }).then(response => resolve (response.json())); 
    });
  });
}

// deprecated function
// export function saveFormPage(formId, selectedPage, data) {
// getToken().then(token => {
//   return fetch(`${BASE_URL}api/form/${formId}/page/${selectedPage}/data`, {
//       headers: {
//           'Content-Type': 'application/json',
//           'Authorization': token
//         },
//         method: 'put',
//         body: JSON.stringify(data)
//     });
//   });
// }
// deprecated function
// export function saveFormAllPages(formId, data) {
//   getToken().then(token => {
//     console.log ("token:", token);
//     return fetch(`${BASE_URL}api/form/${formId}/allpages/data`, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': token
//         },
//         method: 'put',
//         body: JSON.stringify(data)
//     });
//   });
// }


export function sendToCustomer(formId) {
  return new Promise((resolve, reject) => {
    getToken().then(token => {
      return fetch(`${AWS_URL}api/survey/${formId}/change-state/sent-to-customer`, {
          headers: {
              'Accept': 'application/json',
              'Authorization': token
          },
          method: 'post',
          //body: JSON.stringify(data)
      }).then(response => resolve (response.json()));
    });
  });
}

export function customerStartedSurvey(formId) {
  return new Promise((resolve, reject) => {
    getToken().then(token => {
      return fetch(`${AWS_URL}api/survey/${formId}/change-state/in-progress`, {
          headers: {
              'Accept': 'application/json',
              'Authorization': token
          },
          method: 'post',
          //body: JSON.stringify(data)
        }
      ).then(response => resolve (response.json())); 
    });
  });
}


export function surveySubmitted(form, formId) {
  return new Promise((resolve, reject) => {
    getToken().then(token => {
      return fetch(`${AWS_URL}api/survey/${formId}/change-state/returned-to-valmet`, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': token
          },
          method: 'post',
          body: JSON.stringify(form)
        }
      ).then(response => resolve (response.json())); 
    });
  });
}


export function surveyReviewed(form, formId) {
  return new Promise((resolve, reject) => {
    getToken().then(token => {
      return fetch(`${AWS_URL}api/survey/${formId}/change-state/reviewed`, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': token
          },
          method: 'post',
          body: JSON.stringify(form)
        }
      ).then(response => resolve (response.json())); 
    });
  });
}

export function changeCustomerEmail(formId, data) {
  return new Promise((resolve, reject) => {
    getToken().then(token => {
      return fetch(`${AWS_URL}api/survey/${formId}/changecustomeremail`, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': token
          },
          method: 'post',
          body: JSON.stringify(data)
        }
      ).then(response => resolve (response.json())); 
    });
  });
}

export function fetchForms(flag) {
  return new Promise((resolve, reject) => {
    getToken().then(token => {
      if (flag) {
        return fetch(`${AWS_URL}api/surveys/withlinks`, {
            headers: {
              'Accept': 'application/json',
              'Authorization': token
            },
            method: 'GET'
          }
        ).then(response => resolve (response.json())); 
      }
      return fetch(`${AWS_URL}api/surveys`, {
          headers: {
              'Accept': 'application/json',
              'Authorization': token
          },
          method: 'GET'
        }
      ).then(response => resolve (response.json())); 
    });
  });
}

// getsurvey/formid

export function fetchForm(formId) {
  return new Promise((resolve, reject) => {
    getToken().then(token => {
      return fetch(`${AWS_URL}api/getsurvey/${formId}`, {
          headers: {
              'Accept': 'application/json',
              'Authorization': token
          },
          method: 'GET'
      })
      .then(response => response.json()).then(responseJson => {
        /* let returnPromise = new Promise((resolve, reject) => {
          let form = {
            pages: responseJson,
          };  
          resolve(form); 
        });*/
        resolve({pages: responseJson});
      });
    });
  });
}

export function fetchConversionTable() {
  return new Promise((resolve, reject) => {
    getToken().then(token => {
      return fetch(`${AWS_URL}api/survey/conversiontable`, {
          headers: {
              'Accept': 'application/json',
              'Authorization': token
          },
          method: 'GET'
      })
        .then(response => resolve (response.json()));
    });
  });
}

// /survey/{form_id}/userguide-url'
export function fetchUserGuide(formId) {
  return new Promise((resolve, reject) => {
    getToken().then(token => {
      return fetch(`${AWS_URL}api/survey/${formId}/userguide-url`, {
          headers: {
              'Accept': 'application/json',
              'Authorization': token
          },
          method: 'GET'
      })
        .then(response => resolve (response.json()));
    });
  });
}

// /survey/{form_id}/saved-survey-url"
export function fetchCSV(formId) {
  return new Promise((resolve, reject) => {
    getToken().then(token => {
      return fetch(`${AWS_URL}api/survey/${formId}/saved-survey-url`, {
          headers: {
              'Accept': 'application/json',
              'Authorization': token
          },
          method: 'GET'
      })
        .then(response => resolve (response.json()));
    });
  });
}


// WEBPACK FOOTER //
// ./src/services/formService.js